import { css } from 'styled-components/native';

export const brandSpecificNavBorderStyle = css`
  border-top-width: 1px;
  border-top-color: #fff;
`;
